import selectInsurance from 'utils/selectInsurance';

const getConditionAutoAccidentState = ({ patient, insurance, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const selectedInsurance = insurance || selectInsurance(patient['Insurance Information']);
  if (selectedInsurance['Claim Filling Code'] && selectedInsurance['Claim Filling Code'].ID
    && selectedInsurance['Claim Filling Code'].ID === 3 && selectedInsurance['Insurance Info']
    && selectedInsurance['Insurance Info'].State) {
    return selectedInsurance['Insurance Info'].State;
  }
  return null;
};

export default getConditionAutoAccidentState;



// WEBPACK FOOTER //
// ./src/utils/print/getConditionAutoAccidentState.js